import File from '@/components/DesignLibrary/File';
import { FC, useCallback, useContext, useEffect, useState } from 'react';
import * as tsClient from '@tsClient';
import useNoodleApi from '@/hooks/useNoodleApi';
import DocumentPreview from '@/components/Document/DocumentPreview';
import { DocumentAccessContext } from '@/providers/DocumentAccess';
import ProgressIndicator from '@/components/ProgressIndicator';
import s from './DocumentRequestUserDetail.module.scss';

const PayOrganizerFilePreview: FC<{ documentRequestUserFileId: string; documentId: string; onClose?: () => void }> = ({
  documentRequestUserFileId,
  documentId,
  onClose,
}) => {
  const [files, setFiles] = useState<Array<Parameters<typeof File>[0]['document']>>([]);
  const [docRequestUserFile, setDocRequestUserFile] = useState<Awaited<
    ReturnType<typeof tsClient.documentRequests.getDocumentRequestUserFile>
  > | null>(null);
  const {
    fetchingState: { isFetching },
    getData: getDocumentRequestUserFile,
  } = useNoodleApi(tsClient.documentRequests.getDocumentRequestUserFile);
  const { accessToken } = useContext(DocumentAccessContext);

  const fetchDocument = useCallback(async (): Promise<void> => {
    const res = await getDocumentRequestUserFile({
      fileId: documentRequestUserFileId,
    });
    if (res.data) {
      setDocRequestUserFile(res.data);
    }
  }, [documentRequestUserFileId, getDocumentRequestUserFile]);

  useEffect(() => {
    if (docRequestUserFile?.documents) {
      setFiles(docRequestUserFile.documents);
    }
  }, [docRequestUserFile?.documents]);

  useEffect(() => {
    fetchDocument();
  }, [fetchDocument]);

  const document = files.find(({ id }) => id === documentId);

  return (
    <div className={s.fileContainer}>
      {isFetching
        ? (
          <div className={s.fileLoading}>
            <ProgressIndicator />
          </div>
        )
        : (
          <>
            {document
              ? (
                <DocumentPreview
                  document={document}
                  accessToken={accessToken}
                  canDownload={false}
                  canEvaluateWithAi={false}
                  allowRename={false}
                  onClose={onClose}
                  documentRequestFileDescription={docRequestUserFile?.fileDescription}
                  documentRequestFileName={docRequestUserFile?.fileName}
                  internalDataType={docRequestUserFile?.internalDataType}
                />
              )
              : (
                <></>
              )}
          </>
        )}
    </div>
  );
};

export default PayOrganizerFilePreview;
